/* Amara Belle cart drawer behaviour.
   Renders server side; this file handles quantity, remove, the upsell carousel,
   and re-rendering the drawer through the Section Rendering API. */
(function () {
  var SECTION_URL = '/?sections=cart-drawer-section';
  var refreshing = false;

  function drawerEl() { return document.getElementById('cart-drawer'); }

  function rootEl() {
    var d = drawerEl();
    return d ? d.querySelector('[data-tm-cart]') : null;
  }

  function busy(on) {
    var r = rootEl();
    if (r) r.classList.toggle('is-busy', !!on);
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function syncBubble(count) {
    if (typeof count !== 'number') return;
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') {
      try { icon.renderCartBubble(count); } catch (e) {}
    }
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function refresh() {
    if (refreshing) return Promise.resolve();
    refreshing = true;
    return fetch(SECTION_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var html = data['cart-drawer-section'];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-tm-cart]');
        var current = rootEl();
        if (!next || !current) return;
        current.replaceWith(next);
        bindUpsell();
        syncArrows();
      })
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  function changeLine(key, qty) {
    busy(true);
    return post('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { if (cart) syncBubble(cart.item_count); })
      .then(refresh)
      .then(function () { busy(false); });
  }

  function addVariant(id) {
    busy(true);
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }); })
      .then(function (cart) { if (cart) syncBubble(cart.item_count); })
      .then(refresh)
      .then(function () { busy(false); });
  }

  function openDrawer() {
    var d = drawerEl();
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  window.tmCart = {
    refresh: refresh,
    open: openDrawer,
    added: function () {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (cart) { if (cart) syncBubble(cart.item_count); })
        .then(refresh)
        .then(function () { return openDrawer(); });
    }
  };

  /* ---------- upsell carousel ---------- */

  function track() {
    var r = rootEl();
    return r ? r.querySelector('[data-tm-up-track]') : null;
  }

  function syncArrows() {
    var r = rootEl();
    if (!r) return;
    var t = track();
    var prev = r.querySelector('[data-tm-up-prev]');
    var next = r.querySelector('[data-tm-up-next]');
    if (!t || !prev || !next) return;
    var max = t.scrollWidth - t.clientWidth;
    var scrollable = max > 4;
    prev.hidden = !scrollable || t.scrollLeft <= 2;
    next.hidden = !scrollable || t.scrollLeft >= max - 2;
  }

  var recCache = {};
  function loadRecs() {
    var r = rootEl();
    var t = track();
    if (!r || !t || t.dataset.tmRecs === '1') return;
    var pid = r.getAttribute('data-tm-rec-pid');
    var base = r.getAttribute('data-tm-rec-url') || '/recommendations/products';
    if (!pid) return;
    t.dataset.tmRecs = '1';
    function apply(html) {
      var t2 = track();
      if (!html || !t2) return;
      t2.innerHTML = html;
      t2.dataset.tmRecs = '1';
      t2.scrollLeft = 0;
      bindUpsell();
      syncArrows();
    }
    if (recCache.hasOwnProperty(pid)) { apply(recCache[pid]); return; }
    fetch(base + '?product_id=' + pid + '&limit=10&intent=related&section_id=tm-cart-recs')
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var w = doc.querySelector('[data-tm-recs-cards]');
        var html = w && w.querySelector('[data-tm-up-card]') ? w.innerHTML : '';
        recCache[pid] = html;
        apply(html);
      })
      .catch(function () {});
  }

  function bindUpsell() {
    var r = rootEl();
    if (!r) return;
    loadRecs();
    var currency = r.getAttribute('data-tm-currency') || 'USD';
    Array.prototype.slice.call(r.querySelectorAll('[data-tm-up-card]')).forEach(function (card) {
      if (card.dataset.tmBound === '1') return;
      card.dataset.tmBound = '1';

      var variants = [];
      var json = card.querySelector('[data-tm-up-variants]');
      try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }

      var selects = Array.prototype.slice.call(card.querySelectorAll('[data-tm-up-option]'));
      var addBtn = card.querySelector('[data-tm-up-add]');
      var priceEl = card.querySelector('[data-tm-up-prices]');
      if (!selects.length || !addBtn) return;

      function sync() {
        var chosen = selects.map(function (s) { return s.value; });
        var found = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < chosen.length; j++) { if (v.o[j] !== chosen[j]) { ok = false; break; } }
          if (ok) { found = v; break; }
        }
        if (!found) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          return;
        }
        addBtn.dataset.tmVariant = found.id;
        addBtn.disabled = !found.a;
        addBtn.textContent = found.a ? '+ Add' : 'Sold out';
        if (priceEl) {
          var onSale = found.c > found.p;
          var html = '<span class="tm-up__now' + (onSale ? ' is-sale' : '') + '">' + money(found.p, currency) + '</span>';
          if (onSale) html += '<span class="tm-up__was">' + money(found.c, currency) + '</span>';
          priceEl.innerHTML = html;
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', sync); });
      sync();
    });
  }

  /* ---------- events ---------- */

  function onClick(e) {
    var el = e.target.closest ? e.target : null;
    if (!el) return;

    var step = el.closest('[data-tm-qty]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-tm-qty'), parseInt(step.getAttribute('data-tm-to'), 10) || 0);
      return;
    }

    var remove = el.closest('[data-tm-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-tm-remove'), 0);
      return;
    }

    var add = el.closest('[data-tm-up-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      addVariant(add.getAttribute('data-tm-variant'));
      return;
    }

    var prev = el.closest('[data-tm-up-prev]');
    var next = el.closest('[data-tm-up-next]');
    if (prev || next) {
      e.preventDefault();
      var t = track();
      if (t) t.scrollBy({ left: (prev ? -1 : 1) * t.clientWidth, behavior: 'smooth' });
    }
  }

  function boot() {
    var d = drawerEl();
    if (!d || d.dataset.tmCartBound === '1') return;
    d.dataset.tmCartBound = '1';

    d.addEventListener('click', onClick);
    d.addEventListener('scroll', function (e) {
      var el = e.target;
      if (el && el.hasAttribute && el.hasAttribute('data-tm-up-track')) syncArrows();
    }, true);
    d.addEventListener('theme-drawer:open', function () { refresh(); });

    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e && e.promise && typeof e.promise.then === 'function') {
        e.promise.then(function () { refresh(); }).catch(function () {});
      } else {
        refresh();
      }
    });

    bindUpsell();
    syncArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
